import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Logo from '../../elements/Logo';
import GoyName from '../../elements/GoyName';
import { logout, clearSearch } from '../../actions';
import './Header.css';

class Header extends Component {
  render() {
    const loggedIn = this.props.login && this.props.login.token;
    return (
      <div className='header'>
        <div className='header-logo'>
          <Logo/>
        </div>
        <div className='header-wordmark'>
          <GoyName/>
        </div>
        
        {loggedIn &&
          <div className='header-rightpanel'>
            {sessionStorage.user !== '5' &&
            <div className='header-rightpanel-menu'>
              <Link to="/searchBrand">Search Brands</Link>
              <Link to="/createBrand">Add new Brand</Link>
            </div>
            }
            <div className='header-rightpanel-login'>
              {sessionStorage.firstName}
              <Link className='logout' onClick={this.props.logout} to="/login">
                Logout
              </Link>
            </div>
          </div>
        }
        {!loggedIn &&
          <div className='header-rightpanel'>
            <Link to="/login">Login</Link>
          </div>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    login: state.login,
    user: state.user,
  };
}

export default connect(mapStateToProps, { logout, clearSearch })(Header);



// WEBPACK FOOTER //
// ./src/components/header/Header.js